/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "prefabsComponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "prefabsComponents/Navbars/DashboardNavbar";
import Footer from "prefabsComponents/Footer";
import DefaultLineChart from "prefabsComponents/Charts/LineCharts/DefaultLineChart";
import HorizontalBarChart from "prefabsComponents/Charts/BarCharts/HorizontalBarChart";
import PieChart from "prefabsComponents/Charts/PieChart";
import MiniStatisticsCard from "prefabsComponents/Cards/StatisticsCards/MiniStatisticsCard";

// Data
import defaultLineChartData from "layouts/pages/charts/data/defaultLineChartData";
import horizontalBarChartData from "layouts/pages/charts/data/horizontalBarChartData";
import pieChartData from "layouts/pages/charts/data/pieChartData";

function Charts() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <SoftBox mb={3} mt={4}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <DefaultLineChart title="Comparación de ingresos por empresas" chart={defaultLineChartData} />
            </Grid>
            <Grid item xs={12} md={6}>
              <DefaultLineChart title="Comparación de Volumen por empresas" chart={defaultLineChartData} />
            </Grid>
          </Grid>
        </SoftBox>
        <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <HorizontalBarChart title="Top Clientes por Ingresos" chart={horizontalBarChartData} />
            </Grid>
            <Grid item xs={12} md={6}>
              <HorizontalBarChart title="Top Clientes por Volumen" chart={horizontalBarChartData} />
            </Grid>
          </Grid>
        </SoftBox>
        <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <PieChart title="Ingresos por Tipo de Embarque" chart={pieChartData} />
            </Grid>
            <Grid item xs={12} md={6}>
              <PieChart title="Volumen por Tipo de Embarque" chart={pieChartData} />
            </Grid>
          </Grid>
        </SoftBox>
        <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <HorizontalBarChart title="Top Origen por Ingresos" chart={horizontalBarChartData} />
            </Grid>
            <Grid item xs={12} md={6}>
              <HorizontalBarChart title="Top Origen por Volumen" chart={horizontalBarChartData} />
            </Grid>
          </Grid>
        </SoftBox>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Charts;
